<template>
  <div data-locator="profile-view">
    <transition name="app-fade">
      <div :key="path">
        <router-view v-slot="{ Component }">
          <component :is="Component" />
        </router-view>
      </div>
    </transition>
    <ProfileSidebar
      :profileSections="PROFILE_SECTIONS"
    />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

import profileSections from '@/profile/profileSections'
import ProfileSidebar from '@/profile/ProfileSidebar.vue'
import { GlobalMutationTypes } from '@/store/modules/global/mutation_types'

export default {
  name: 'Profile',
  components: {
    ProfileSidebar,
  },
  data () {
    return {
      PROFILE_SECTIONS: profileSections,
    }
  },
  computed: {
    ...mapGetters('user', ['canCurrentUserSign']),
    ...mapState('user', ['profile']),
    path () {
      const matchedSection = this.PROFILE_SECTIONS.find(section =>
        this.$route.path.startsWith(`/profile/${section.key}`), // handles dynamic urls
      )
      return matchedSection ? `/profile/${matchedSection.key}` : ''
    },
  },
  created () {
    this.$store.commit('global/' + GlobalMutationTypes.SET_BADGE_PROFILE_VISIBLE, !this.canCurrentUserSign)
  },
}
</script>
